<template>

  <div style="width: 100%;height: 100%;">
    <bigdata-table
      @contextmenu.prevent.native="onBigDataTableRightClick($event)"
      ref="bigDataTableRef"
      id="bigdataTable"
      v-model="currentPageContent"
      :row-num="20"
      :col-num="bigDataColumnsCount"
      fixed
      stripe0
      :index-width="80"
      :col-width="200"
      :header-height="20"
      :row-height="30"
      :can-edit="bigDataCanEdit"
      :at-right-cell-posi="20"
      :at-left-cell-posi="40"
      :columns="columns"
      :fixed-col="0"
      :sort-index="bigDataSortIndex"
      :default-sort="bigDataDefaultSort"
      selectable
      paste
      :beforeSave="bigDataBeforeSave"
      :disabled-hover="false"
      :highlightRow="true"
      @on-success-save="bigDataHandleSuccessEdit"
      @on-fail-save="bigDataHandleFailEdit"
      @on-moving-on-header="bigDataHandleMoving"
      @on-index-change="bigDataHandleClickIndex"
      @on-click-tr="bigDataOnClickTr"
    ></bigdata-table>
  </div>

</template>

<script>
  import Vue from 'vue'
  import { GPS } from '@/libs/positonUtils'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import { explainAlarmSign, explainState, explainDirection } from '@/libs/jt808util'

  import bigdataTable from '_c/vue-bigdata-table'
    export default {
        name: "locate-table-model",
      components: {
        bigdataTable,
      },
      data(){
          return{
            /**
             * 大数据表格参数
             */
            currentPageContent: [],
            bigDataColumnsCount: 10,
            bigDataCanEdit: false,
            bigDataSortIndex: [2, 3, 4, 5],
            bigDataDefaultSort: { 0: 'up' },
            bigDataTableWebTableColumnsModal: false,

            registrationNum: '',

            columns: [
              {
                title: '车牌号',
                // key: 'terminalNum',
                align: 'center',
                ellipsis: 'true',
                width: 110,
                cellRender: (h, params) => {
                  return h('label', params.value)
                }
              },
              {
                title: '定位时间',
                // key: 'locateDatetimeLongValue',
                // sortable: 'custom',
                align: 'center',
                ellipsis: 'true',
                width: 190,
                cellRender: (h, params) => {
                  return h('label', params.value)
                }
              },
              {
                title: '接收时间',
                // key: 'recvDatetimeLongValue',
                // sortable: 'custom',
                align: 'center',
                ellipsis: 'true',
                width: 190,
                cellRender: function (h, params) {
                  return h('label', params.value)
                }
              },
              {
                title: '经度',
                // key: 'longitude',
                ellipsis: 'true',
                width: 120,
                align: 'center',
                cellRender: function (h, params) {
                  return h('label', params.value)
                }
              },
              {
                title: '纬度',
                // key: 'latitude',
                ellipsis: 'true',
                width: 120,
                align: 'center',
                cellRender: function (h, params) {
                  return h('label', params.value)
                }
              },
              {
                title: '方向',
                // key: 'direction',
                ellipsis: 'true',
                align: 'center',
                width: 60,
                cellRender: function (h, params) {
                  return h('label', explainDirection(params.value))
                }
              },
              {
                title: '速度(km/h)',
                // key: 'speed',
                ellipsis: 'true',
                width: 80,
                align: 'center',
                cellRender: function (h, params) {
                  return h('label', params.value)
                }
              },
              {
                title: '状态',
                // key: 'address',
                width: 630,
                align: 'center',
                cellRender: (h, params) => {
                  let s = ''
                  let state = params.value.split(',')[0]
                  let sl = explainState(state)
                  sl.forEach(item => {
                    s += item + '|'
                  })
                  let b = ''
                  let afterUpload = params.value.split(',')[1]
                  if (afterUpload == 'true') {
                    b = '补传数据'
                  }
                  return h('span', [
                    h('span', {
                      style: {
                        display: 'inline-block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }
                    }, s),
                    h('span', {
                      style: {
                        display: 'inline-block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: '#ff0000'
                      }
                    }, b)
                  ])
                }
              },
              {
                title: '报警',
                align: 'center',
                width: 300,
                cellRender: (h, params) => {
                  return h('span', {
                    style: {
                      display: 'inline-block',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }
                  }, explainAlarmSign(params.value))
                }
              },
              {
                title: '位置',
                // key: 'address',
                minWidth: 370,
                align: 'center',
                cellRender: function (h, params) {
                  return h('label', params.value)
                }
              },
              {
                title: '累计里程(km)',
                // key: 'mileage',
                ellipsis: 'true',
                width: 100,
                align: 'center',
                cellRender: function (h, params) {
                  return h('label', params.value)
                }
              }
            ], // cloumn,
          }
      },
      methods:{
        /***
         *  封装为table二维数组
         */

        makecurrentPageContent (currentPageContent, registrationNum) {
          console.log(currentPageContent)
          console.log(registrationNum)
          this.registrationNum = registrationNum
          let arry = Array(currentPageContent.length).fill(0).map(x => Array(this.columns.length).fill(0))
          for (var i = 0; i < currentPageContent.length; i++) {
            arry[i][0] = this.registrationNum
            arry[i][1] = new Date(currentPageContent[i].locateDatetimeLongValue).Format('yyyy年MM月dd日 hh:mm:ss')
            arry[i][2] = new Date(currentPageContent[i].recvDatetimeLongValue).Format('yyyy年MM月dd日 hh:mm:ss')
            arry[i][3] = currentPageContent[i].longitude
            arry[i][4] = currentPageContent[i].latitude
            arry[i][5] = currentPageContent[i].direction
            arry[i][6] = currentPageContent[i].speed / 10
            // console.log(currentPageContent[i].state)
            // console.log(currentPageContent[i].afterUpload)
            // console.log(currentPageContent[i].state + ',' + currentPageContent[i].afterUpload)
            arry[i][7] = currentPageContent[i].state + ',' + currentPageContent[i].afterUpload
            arry[i][8] = currentPageContent[i].alarmSign
            arry[i][9] = currentPageContent[i].address
            arry[i][10] = currentPageContent[i].mileage
          }
          this.currentPageContent = arry
        },
        onBigDataTableRightClick (e) {
          this.$refs.bigDataTableContextMenuRef.showMenu(e, this.$el)
        },
        bigDataBeforeSave ({ row, col, value }) {
          return (row + 1) % 2
        },
        bigDataHandleSuccessEdit ({ row, col, value, initRowIndex }) {
          console.log(`第${row + 1}行第${col + 1}列改为${value}`)
        },
        bigDataHandleFailEdit (res) {
          console.log('偶数行不能编辑')
        },
        bigDataHandleMoving (e) {

        },
        bigDataHandleClickIndex (index) {
          this.indexRenderParams.index = index
          console.log(1)
        },
        /**
         *表格点击事件
         */
        bigDataOnClickTr (index) {
          console.log(index)
          // this.onSliderChange(index)
          this.$emit('onSliderChange', index)
        },
        setHighlightRow(e){
          console.log(e)
          this.$refs.bigDataTableRef.setHighlightRow(e)
        },
        scrollToRow(e){
          console.log(e)
          this.$refs.bigDataTableRef.scrollToRow(e)
        },
      },
      mounted() {
        this.bigDataColumnsCount = this.columns.length
      }
    }
</script>

<style scoped>

</style>
